import { render, staticRenderFns } from "./ListPickup.vue?vue&type=template&id=0388cdd4&scoped=true"
import script from "./ListPickup.vue?vue&type=script&lang=js"
export * from "./ListPickup.vue?vue&type=script&lang=js"
import style0 from "./ListPickup.vue?vue&type=style&index=0&id=0388cdd4&prod&scoped=true&lang=css"
import style1 from "./ListPickup.vue?vue&type=style&index=1&id=0388cdd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0388cdd4",
  null
  
)

export default component.exports